export var AccountValueType;
(function (AccountValueType) {
    AccountValueType["DOLLARS"] = "DOLLARS";
    AccountValueType["STEEM"] = "STEEM";
    AccountValueType["HIDDEN"] = "HIDDEN";
})(AccountValueType || (AccountValueType = {}));
